<div class="flex flex-column form-typography">
  <div class="margin-bottom-xsmall text-right">
    <button mat-button type="button" class="padding-none raptor-medical-interstitial-close-button" (click)="onClose()">
      <mat-icon class="clear" aria-hidden="false" aria-label="close"></mat-icon>
    </button>
  </div>

  <div class="raptor-medical-interstitial-content" data-dd-privacy="mask">
    <div class="verisk-container" id="BlackBoxContainer"></div>
  </div>
</div>
